import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnShare } from '@lib/api/entities';
import { SnFormFieldConfig } from '@lib/form';
import { SN_DRAWER_DATA, SnDrawerRef } from '@lib/ui/drawer';

import { ISnIsSharable } from '../../interfaces';
import { SnShareFieldsGeneratorService } from '../../services/share-fields-generator.service';

export interface IShareInviteDrawerData {
  object: ISnIsSharable;
  createHandler: (objectId: string, formData: any) => Observable<SnShare | SnShare[]>;
}

@Component({
  selector: 'sn-add-share-drawer',
  templateUrl: './share-invite-drawer.container.html',
})
export class ShareInviteDrawerContainer implements OnDestroy {
  public readonly form = new UntypedFormGroup({});
  public readonly formModel = {};

  public readonly additionalFields: SnFormFieldConfig[];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(SN_DRAWER_DATA) public readonly data: IShareInviteDrawerData,
    private readonly _drawerRef: SnDrawerRef,
    shareFieldsGenerator: SnShareFieldsGeneratorService,
  ) {
    this.additionalFields = shareFieldsGenerator.getAdditionalFields(data.object.contentType);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onSubmit(formData: any[]): void {
    this.data
      .createHandler(this.data.object.id, formData)
      .pipe(takeUntil(this._destroy$))
      .subscribe((shares) => {
        this._drawerRef.close(shares);
      });
  }
}
